import { render, staticRenderFns } from "./CompensationModal.vue?vue&type=template&id=51d9d621&scoped=true&"
import script from "./CompensationModal.vue?vue&type=script&lang=js&"
export * from "./CompensationModal.vue?vue&type=script&lang=js&"
import style0 from "./CompensationModal.vue?vue&type=style&index=0&id=51d9d621&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d9d621",
  null
  
)

export default component.exports